import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack } from '@mui/material';

export interface PurchaseFormValues {
  date: string;
  quantity: number | '';
  pricePerShare: number | '';
  cambio?: number | '';
}

interface PurchaseFormProps {
  open: boolean;
  initialValues?: PurchaseFormValues;
  onClose: () => void;
  onSubmit: (values: PurchaseFormValues) => void;
}

export default function PurchaseForm({ open, initialValues, onClose, onSubmit }: PurchaseFormProps) {
  const [values, setValues] = useState<PurchaseFormValues>(
    initialValues || { date: '', quantity: '', pricePerShare: '', cambio: '' }
  );

  // Update form values when initialValues changes
  useEffect(() => {
    if (initialValues) {
      setValues(initialValues);
    } else {
      setValues({ date: '', quantity: '', pricePerShare: '', cambio: '' });
    }
  }, [initialValues]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: name === 'quantity' || name === 'pricePerShare' || name === 'cambio' ? (value === '' ? '' : Number(value)) : value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ ...values });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{initialValues ? 'Editar compra' : 'Adicionar compra'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Stack spacing={2}>
            <TextField
              label="Data"
              name="date"
              type="date"
              value={values.date}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              required
            />
            <TextField
              label="Quantidade"
              name="quantity"
              type="number"
              value={values.quantity}
              onChange={handleChange}
              fullWidth
              required
            />
            <TextField
              label="Preço por unidade"
              name="pricePerShare"
              type="number"
              value={values.pricePerShare}
              onChange={handleChange}
              fullWidth
              required
            />
            <TextField
              label="Câmbio (cotação → EUR)"
              name="cambio"
              type="number"
              value={values.cambio ?? ''}
              onChange={handleChange}
              fullWidth
              helperText="Opcional: usado para recalcular os valores em EUR ao guardar"
            />
            
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained">{initialValues ? 'Atualizar' : 'Adicionar'}</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
